import { render } from "./Download.vue?vue&type=template&id=a5ef210a&scoped=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=a5ef210a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a5ef210a"

export default script